import React from 'react'
import './skills.css'

function Skills() {
  return (
    <section id="skills">
    <main data-aos="fade-in" className="container skill__container aos-init aos-animate">
    <h2 className="text_skill_center">Skills</h2>
    <p className="text_skill_center">Those are my skills below</p>
    <p className="text_skill">HTML</p>
    <div>
    <div className="skills html">90%</div>
    </div>

    <p className="text_skill">CSS</p>
    <div>
    <div className="skills css">80%</div>
    </div>

    <p className="text_skill">Bootstrap</p>
    <div>
    <div className="skills bootstrap">80%</div>
    </div>

    <p className="text_skill">JavaScript</p>
    <div>
    <div className="skills js">65%</div>
    </div>

    <p className="text_skill">React.js</p>
    <div>
    <div className="skills react">80%</div>
    </div>

    <p className="text_skill">Vue.js</p>
    <div>
    <div className="skills vue">70%</div>
    </div>

    <p className="text_skill">Node.js</p>
    <div>
    <div className="skills node">60%</div>
    </div>

    <p className="text_skill">PHP</p>
    <div>
    <div className="skills php">90%</div>
    </div>

    <p className="text_skill">Wordpress</p>
    <div>
    <div className="skills wordpress">90%</div>
    </div>

    <p className="text_skill">Laravel</p>
    <div>
    <div className="skills laravel">70%</div>
    </div>
    
    <p className="text_skill">Drupal</p>
    <div>
    <div className="skills drupal">65%</div>
    </div>

    <p className="text_skill">Magento</p>
    <div>
    <div className="skills magento">60%</div>
    </div>

    <p className="text_skill">MySQL</p>
    <div>
    <div className="skills mysql">60%</div>
    </div>

    </main>
    </section>
  )
}

export default Skills